import { api } from "./client";
import type { WorkItemId } from "./types";

export type ActivityType = "comment" | "agent_update" | "system_event";
export type AuthorType = "user" | "agent" | "system";

export interface ActivityAuthor {
  id: string | null;
  author_type: AuthorType;
  display_name: string | null;
  email: string | null;
  avatar_url: string | null;
}

export interface Activity {
  id: string;
  work_item_id: WorkItemId;
  activity_type: ActivityType;
  author: ActivityAuthor;
  body: string;
  metadata: unknown;
  created_at: string;
}

export interface ActivityListResponse {
  items: Activity[];
  next_cursor: string | null;
}

export interface ListActivitiesOptions {
  cursor?: string;
  limit?: number;
}

export function listActivities(
  workItemId: WorkItemId,
  options?: ListActivitiesOptions,
): Promise<ActivityListResponse> {
  const params = new URLSearchParams();
  if (options?.cursor) params.set("cursor", options.cursor);
  if (options?.limit !== undefined) params.set("limit", String(options.limit));
  const query = params.toString();
  const path = query
    ? `/work-items/${workItemId}/activity?${query}`
    : `/work-items/${workItemId}/activity`;
  return api.get<ActivityListResponse>(path);
}

export function createComment(
  workItemId: WorkItemId,
  body: string,
): Promise<Activity> {
  return api.post<Activity>(`/work-items/${workItemId}/comments`, { body });
}
